import { computed } from 'vue'
import { AmsItem } from '../services/amsSearch/amsSearch.interface'
import { ScreenSize } from '@sunrise/types'
import { screenSizeDetection } from '@sunrise/shared'

export const useItemResizedImageURL = (item: AmsItem) => {
    const currentScreenSize = useCurrentScreenSize()
    return computed((): string => {
        if (!item.resizedImages?.length) {
            return ''
        }

        return item.resizedImages[0][currentScreenSize.value] as string
    })
}

const useCurrentScreenSize = () => {
    const { isScreenXS, isScreenS, isScreenM, isScreenL, isScreenXL, isScreenXXL } = screenSizeDetection()

    return computed(() => {
        return (
            [
                { enabled: isScreenXXL.value, size: ScreenSize.XXL },
                { enabled: isScreenXL.value, size: ScreenSize.XL },
                { enabled: isScreenL.value, size: ScreenSize.L },
                { enabled: isScreenM.value, size: ScreenSize.M },
                { enabled: isScreenS.value, size: ScreenSize.S },
                { enabled: isScreenXS.value, size: ScreenSize.XS },
            ].find(({ enabled }) => enabled) as { enabled: boolean; size: ScreenSize }
        ).size
    })
}
